import React, { createContext, useContext, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { baseURLPublic } from '../../config/BaseUrl';

const Access = createContext({ enabled: false, loading: false, error: false, refresh: () => {} });

export function GalleryAccessProvider({ children }) {
  useLocation(); // Re-read login storage when navigating after login/logout.
  let token = ''; let userId = '';
  try { token = localStorage.getItem('token_verify') || ''; userId = JSON.parse(localStorage.getItem('users') || '{}')?.id || ''; } catch (_) { /* Closed until authenticated. */ }
  const key = token && userId ? `${userId}:${token}` : '';
  const [result, setResult] = useState({});
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!key) return undefined;
    let active = true;
    setResult({ key, loading: true, enabled: false });
    baseURLPublic.get('social-gallery-v2/capabilities', { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => {
      if (active) setResult({ key, loading: false, enabled: data?.data?.enabled === true });
    }).catch(() => { if (active) setResult({ key, loading: false, enabled: false, error: true }); });
    return () => { active = false; };
  }, [key, token, reload]);
  const value = key && result.key === key ? result : { enabled: false, loading: !!key };
  return <Access.Provider value={{ enabled: !!value.enabled, loading: !!value.loading, error: !!value.error,
    refresh: () => setReload((value) => value + 1) }}>{children}</Access.Provider>;
}

export const useGalleryAccess = () => useContext(Access);

export function GalleryAccessGate({ children }) {
  const access = useGalleryAccess();
  if (access.loading) return <main className="sg-public-state" role="status">Loading Social Gallery…</main>;
  if (access.error) return <main className="sg-public-state"><p role="alert">Could not check Social Gallery access.</p><button type="button" onClick={access.refresh}>Try again</button></main>;
  return access.enabled ? children : <Redirect to="/dashboard" />;
}
